import { initialState } from "../context/shipContext";
import { ITEM_OPTIONS } from "../data/items";
import {
  COMPLETE_SENDER_DETAILS_STEP,
  PREVIOUS_STEP,
  COMPLETE_RECEIVER_DETAILS_STEP,
  COMPLETE_ITEM_DETAILS_STEP,
  COMPLETE_RATE_SELECTION_STEP,
  COMPLETE_CHECKOUT_DETAILS_STEP,
  SELECT_QUOTE,
  RESET_STATE,
  SET_KEPT_ADDRESS,
  SET_AUTOCOMPLETE_ENABLED_FROM,
  SET_AUTOCOMPLETE_ENABLED_TO,
  HYDRATE_DRAFT,
} from "./types";

export const shipReducer = (state, { type, payload }) => {
  switch (type) {
    case SELECT_QUOTE:
      return {
        ...state,
        selectedRate: payload.quote,
        from: {
          ...state.from,
          ...(payload.request.from.isExistingAddress
            ? {
                isExistingAddress: payload.request.from.isExistingAddress,
                existingAddress: payload.request.from.existingAddress,
                shouldSaveAddress: payload.request.from.shouldSaveAddress,
              }
            : {
                country: payload.request.from.country,
                zip: payload.request.from.zip,
              }),
        },
        to: {
          ...state.to,
          country: payload.request.to.country,
          zip: payload.request.to.zip,
        },
        item: {
          ...state.item,
          type: ITEM_OPTIONS[0],
          length: payload.request.item.length,
          width: payload.request.item.width,
          height: payload.request.item.height,
          weight: payload.request.item.weight,
          isImperial: payload.request.measurement === "IMPERIAL" ? true : false,
        },
      };
    case COMPLETE_SENDER_DETAILS_STEP: {
      const { isExistingAddress } = payload;

      return {
        ...state,
        from: {
          ...state.from,
          isExistingAddress: !!isExistingAddress,
          ...(isExistingAddress
            ? {
                // Existing address selected → populate existingAddress
                existingAddress: payload.existingAddress,
                // Clear manual entry fields
                name: "",
                address1: "",
                address2: "",
                city: "",
                state: {},
                country: {},
                zip: "",
                phone: "",
                email: "",
                shouldSaveAddress: false,
              }
            : {
                // Manual entry → populate manual fields
                name: payload.name,
                address1: payload.address1,
                address2: payload.address2,
                city: payload.city,
                state: payload.state,
                country: payload.country,
                zip: payload.zip,
                phone: payload.phone,
                email: payload.email,
                // Clear existing address
                existingAddress: {},
                shouldSaveAddress: payload.shouldSaveAddress,
              }),
        },
        step: state.step + 1,
      };
    }
    case COMPLETE_RECEIVER_DETAILS_STEP:
      return {
        ...state,
        to: {
          ...payload,
          autocompleteEnabled: state.to.autocompleteEnabled,
        },
        step: state.step + 1,
      };
    case COMPLETE_ITEM_DETAILS_STEP:
      return {
        ...state,
        item: payload.item,
        rates: payload.rates,
        step: state.step + 1,
      };
    case COMPLETE_RATE_SELECTION_STEP:
      return {
        ...state,
        selectedRate: payload,
        step: state.step + 1,
      };
    case COMPLETE_CHECKOUT_DETAILS_STEP:
      return {
        ...state,
        orderId: payload,
        step: state.step + 1,
      };
    case PREVIOUS_STEP:
      return {
        ...state,
        step: state.step - 1,
      };
    case RESET_STATE:
      return initialState;
    case SET_KEPT_ADDRESS: {
      const { formKey, addressData, addressKey } = payload;
      return {
        ...state,
        validatedAddresses: {
          ...state.validatedAddresses,
          [formKey]: { addressKey, data: addressData },
        },
      };
    }
    case SET_AUTOCOMPLETE_ENABLED_FROM:
      return {
        ...state,
        from: {
          ...state.from,
          autocompleteEnabled: payload,
        },
      };
    case SET_AUTOCOMPLETE_ENABLED_TO:
      return {
        ...state,
        to: {
          ...state.to,
          autocompleteEnabled: payload,
        },
      };

    case HYDRATE_DRAFT: {
      const { step, from, to, item } = payload;

      return {
        ...state,
        step: Math.min(step ?? 0, 2),

        from: from ?? initialState.from,
        to: to ?? initialState.to,
        item: item ?? initialState.item,

        // Invalidate transient state
        rates: [],
        selectedRate: {},
        orderId: null,
      };
    }
    default:
      return state;
  }
};
